import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hybse-admin-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.css']
})
export class IssuerAddUserComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/BEX-KYC-Admin/src/app/components/pages/users/issuers/add-user/add-user.component.ts